import { render, staticRenderFns } from "./spread_animation.vue?vue&type=template&id=39ab5b4a&scoped=true"
import script from "./spread_animation.vue?vue&type=script&lang=js"
export * from "./spread_animation.vue?vue&type=script&lang=js"
import style0 from "./spread_animation.vue?vue&type=style&index=0&id=39ab5b4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab5b4a",
  null
  
)

export default component.exports